import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Dialog, IconButton } from '@mui/material';
import React from 'react';
import { CollaboraFrame } from 'components/collabora-frame/collabora-frame';
import { orderFileId, useCollaboraSession } from 'services/auth';

export const DocumentViewer = ({ open, handleClose, orderId, archive_id }) => {
  const collabora = useCollaboraSession(
    orderId && archive_id ? orderFileId(orderId, archive_id) : null,
    open,
    () => handleClose(''),
  );
  return (
    <Dialog fullScreen open={open} onClose={() => handleClose('')}>
      <Box>
        <IconButton onClick={() => handleClose('')} size="large">
          <FontAwesomeIcon icon="times" />
        </IconButton>
      </Box>
      <Box height="100%">
        <CollaboraFrame session={collabora} />
      </Box>
    </Dialog>
  );
};

export default DocumentViewer;
